export default "__VITE_ASSET__C2Rcf4i___"